module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/social/googleplay-a9dcc7f72ba411c75a41fcb3b9bbecc9.svg";